import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { withTranslation } from 'react-i18next';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import Notification from '../Notifications/Notification';
import SystemNotification from '../SystemNotification';
import { BiData } from '@wix/da-bi/pkg/events';
export class CommentDeleteNotification extends React.Component {
    render() {
        var _comment_user;
        const { id, t, queueName, comment, insideModal, isCommentReduxReady } = this.props;
        return /*#__PURE__*/ React.createElement(Notification, {
            id: id,
            queueName: queueName,
            cardComponent: SystemNotification,
            cardProps: {
                iconComponent: CommentIcon,
                actions: [
                    {
                        type: 'negative',
                        label: t('comment.action.delete.undo'),
                        onClick: this.onUndo,
                        disabled: !isCommentReduxReady,
                        biData: BiData({
                            evid: 188,
                            commenterid: (_comment_user = comment.user) === null || _comment_user === void 0 ? void 0 : _comment_user.useridUuid,
                            commentid: comment.commentId,
                            itemid: comment.itemId,
                            typeid: comment.typeId,
                            is_comment_thread: insideModal ? 1 : 0
                        })
                    }
                ]
            }
        }, t('comment.info.deleted'));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onUndo", ()=>{
            this.props.onUnhide(this.props.comment);
        });
    }
}
export default withTranslation()(CommentDeleteNotification);

//# sourceMappingURL=CommentDeleteNotification.js.map